module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      J. Sheridan Le Fanu, Sam Knight, Bailey Finn\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("J. Sheridan Le Fanu (1814–1873) was an Irish writer who helped develop the ghost story genre in the nineteenth century. Born to a family of writers, Le Fanu released his first works in 1838 in "), _c('I', [_vm._v("Dublin University Magazine")]), _vm._v(", which he would go on to edit and publish in 1861. Some of Le Fanu’s most famous Victorian Gothic works include "), _c('I', [_vm._v("Carmilla")]), _vm._v(", "), _c('I', [_vm._v("Uncle Silas")]), _vm._v(", and "), _c('I', [_vm._v("In a Glass Darkly")]), _vm._v(". His writing has inspired other great authors of horror and thriller literature such as Bram Stoker and M. R. James.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17iCMnk/tc-custom/9781680576665.jpg?1737196545400",
      "alt": "This image is the cover for the book Watcher and Other Weird Stories"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Watcher and Other Weird Stories\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A captain on the run from his demons…literally!   A trapped countess fights for her life in an unfamiliar estate.   A love-struck painter searches to save his love against the mysterious suitor that stole her.   And more!   The Watcher and Other Weird Stories contains six Victorian cautionary tales. Joseph Sheridan Le Fanu shines the light on not only the shadows in the cobblestone alleys but the shadows in the human soul. This is a fine new edition to the classic collection by one of the early masters of supernatural horror with a new foreword by Sam Knight!   Bring your lantern, check your windows and paintings.    You’ll love diving into these old haunts!")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    WordFire Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0